// extracted by mini-css-extract-plugin
module.exports = {"emptyTab":"EmptyTab_emptyTab__2IWut"};